module.exports = __webpack_public_path__ + "img/logo.baae2916.png";